/** From this share of the quota the fill turns red and a one-line note appears. */
export const NEAR_LIMIT_FRACTION = 0.9;

export interface UsageLevel {
  /** Fill width, clamped to 0..1 so it never passes the goal line. */
  fraction: number;
  nearLimit: boolean;
  full: boolean;
}

/** How full a quota is. A missing or zero quota reads as empty, with no warning. */
export function usageLevel(used: number, quota: number): UsageLevel {
  if (quota <= 0) return { fraction: 0, nearLimit: false, full: false };
  const ratio = used / quota;
  return {
    fraction: Math.min(1, Math.max(0, ratio)),
    nearLimit: ratio >= NEAR_LIMIT_FRACTION,
    full: ratio >= 1,
  };
}
